// Helper to reduce boilerplate in setters
export default function createSetter(set, key) {
  return (value) => set({ [key]: value });
}
